<template>
  <div class="hide-module">
    <div class="head">
      <span>
        <i class="iconfont el-button--text" :class="'icon--' + item.name"></i>{{item.name_cn}}
      </span>
      <p class="operation pull-right">
        <span @click="showModule(item, index)">显示</span>
      </p>
    </div>
    <div class="detail">
      <i class="iconfont icon--hide"></i>
      <p>模块已隐藏将不会在主页显示</p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    item: Object,
    index: Number
  },
  data () {
    return {

    }
  },
  methods: {
    showModule (item, index) {
      this.$emit('updateModule', item, index, true)
    }
  }
}
</script>
<style lang="scss">
  @import './index.scss';
</style>



// WEBPACK FOOTER //
// src/pages/Index/HideModule/index.vue